<template>
  <div class="table-block" :style="containerStyles">
    <div class="table-wrapper">
      <table class="custom-table" :style="tableStyles">
        <!-- Header -->
        <thead v-if="showHeader">
          <tr>
            <th 
              v-for="(header, index) in headers" 
              :key="`header-${index}`"
              :style="headerStyles"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        
        <!-- Body -->
        <tbody>
          <tr 
            v-for="(row, rowIndex) in rows" 
            :key="`row-${rowIndex}`"
            :style="getRowStyles(rowIndex)"
          >
            <td 
              v-for="(cell, cellIndex) in row" 
              :key="`cell-${rowIndex}-${cellIndex}`"
              :style="cellStyles"
            >
              <div v-html="cell"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableBlock',
  props: {
    headers: {
      type: Array,
      default: () => ['Columna 1', 'Columna 2', 'Columna 3']
    },
    rows: {
      type: Array,
      default: () => [
        ['Dato 1', 'Dato 2', 'Dato 3'],
        ['Dato A', 'Dato B', 'Dato C'],
        ['Dato X', 'Dato Y', 'Dato Z']
      ]
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    headerBackgroundColor: {
      type: String,
      default: '#007bff'
    },
    headerTextColor: {
      type: String,
      default: '#ffffff'
    },
    rowBackgroundColor: {
      type: String,
      default: '#ffffff'
    },
    alternateRowColor: {
      type: String,
      default: '#f8f9fa'
    },
    borderColor: {
      type: String,
      default: '#dee2e6'
    },
    textColor: {
      type: String,
      default: '#2c3e50'
    },
    fontSize: {
      type: String,
      default: '14px'
    },
    cellPadding: {
      type: String,
      default: '12px'
    },
    borderWidth: {
      type: String,
      default: '1px'
    },
    borderStyle: {
      type: String,
      default: 'solid'
    },
    fullWidth: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    containerStyles() {
      return {
        textAlign: this.align,
        margin: '20px 0'
      }
    },
    tableStyles() {
      return {
        width: this.fullWidth ? '100%' : 'auto',
        borderCollapse: 'collapse',
        fontSize: this.fontSize,
        fontFamily: 'Arial, sans-serif',
        margin: '0 auto',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        borderRadius: '8px',
        overflow: 'hidden'
      }
    },
    headerStyles() {
      return {
        backgroundColor: this.headerBackgroundColor,
        color: this.headerTextColor,
        padding: this.cellPadding,
        textAlign: 'left',
        fontWeight: '600',
        border: `${this.borderWidth} ${this.borderStyle} ${this.borderColor}`
      }
    },
    cellStyles() {
      return {
        padding: this.cellPadding,
        textAlign: 'left',
        border: `${this.borderWidth} ${this.borderStyle} ${this.borderColor}`,
        color: this.textColor
      }
    }
  },
  methods: {
    getRowStyles(index) {
      return {
        backgroundColor: index % 2 === 0 ? this.rowBackgroundColor : this.alternateRowColor
      }
    }
  }
}
</script>

<style scoped>
.table-block {
  width: 100%;
  overflow-x: auto;
}

.table-wrapper {
  min-width: 100%;
  overflow-x: auto;
}

.custom-table {
  border-radius: 8px;
  overflow: hidden;
}

.custom-table tr:hover {
  background-color: rgba(0, 123, 255, 0.1) !important;
}

/* Responsive para emails */
@media only screen and (max-width: 600px) {
  .table-wrapper {
    overflow-x: scroll;
  }
  
  .custom-table {
    min-width: 500px;
    font-size: 12px;
  }
  
  .custom-table th,
  .custom-table td {
    padding: 8px !important;
    font-size: 12px !important;
  }
}

/* Estilos específicos para clientes de email */
.custom-table th {
  mso-line-height-rule: exactly;
  line-height: 1.4;
}

.custom-table td {
  mso-line-height-rule: exactly;
  line-height: 1.4;
  vertical-align: top;
}
</style> 